const content  = {
    EN: {
      ID: 'Item No.',  
      Description: 'DESCRIPTION',
      SampleDescription: 'SAMPLE DESCRIPTION',
      Inventory: 'INVENTORY',
      SpecialWeight: 'SPECIAL WEIGHT',
      Composition: 'COMPOSITION',
      Width: 'WIDTH',
      UnitPrice: 'UNIT PRICE',
    },
    GR: {
        ID: 'ΚΩΔΙΚΟΣ',
        Description: 'ΠΕΡΙΓΡΑΦΗ',
        SampleDescription: 'ΣΥΝΤΟΜ/ΦΙΑ ΔΕΙΓΜΑΤΟΣ',
        Inventory: 'ΑΠΟΘΕΜΑ',
        SpecialWeight: 'ΕΙΔΙΚΟ ΒΑΡΟΣ',
        Composition: 'ΣΥΝΘΕΣΗ',
        Width: 'ΠΛΑΤΟΣ',
        UnitPrice: 'ΤΙΜΗ ΜΟΝΑΔΑΣ',
    },
  };

  export default content;


// WEBPACK FOOTER //
// ./src/components/itemcard/content.js